import React from 'react';

import { format } from 'date-fns';
import locale from 'date-fns/locale/pt-BR';

import { capitalize } from '~/utils/strings';

import { Container, Titulo, Body } from './styles';

const Item = ({ data, onPress, disabled }) => (
  <Container
    id='item'
    onClick={() => {
      if (!disabled) {
        onPress(data);
      }
    }}
  >
    <Titulo>{data?.nome}</Titulo>
    <Body>{data?.endereco}</Body>
    <Body>{capitalize(format(data?.date, "EEEE dd/MM 'às' HH:mm", { locale }))}</Body>
  </Container>
);

export default Item;
